import { GlButton, GlIcon, GlSkeletonLoader } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'FeatureLibraryExplorePageButton',
    components: {
        GlButton,
        GlIcon,
        GlSkeletonLoader
    },
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        subtitle: {
            type: String,
            required: false,
            default: ''
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'select'
    ]
};
